var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgImgProfileDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 28,
    viewBox: "0 0 25 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 27.9603C24.0001 23.7629 18.8964 20.3604 12.6002 20.3604C6.30396 20.3604 1.2002 23.7629 1.2002 27.9603",
    stroke: "#A4A4A4",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32807 9.0073C5.32807 4.70361 8.81201 1.21967 13.1157 1.21967C17.4194 1.21967 20.9033 4.70361 20.9033 9.0073C20.9033 13.311 17.4194 16.7949 13.1157 16.7949",
    stroke: "#A4A4A4",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImgProfileDefault);
export default __webpack_public_path__ + "static/media/img-profile-default.0c2a1623d716ac0daba4ee0b207b8cb1.svg";
export { ForwardRef as ReactComponent };